import { indexNotSet } from '@/core';

export const indexIsSet = (index: number) => {
  return index > indexNotSet;
};
